import type { SimilarityJob } from "../../api/similarity";
export function buildSimilarityRecovery(job: Partial<SimilarityJob>) {
  const sitemapUrl = job.sitemap_url || "";
  const fileType =
    job.job_type === "excel_upload"
      ? ("excel" as const)
      : job.job_type === "sitemap_analysis"
        ? ("sitemap" as const)
        : null;
  return {
    name: job.name || "",
    sitemapUrl,
    requiresUpload: !!fileType,
    fileType,
    segmentFilters: job.segment_filters ?? undefined,
  };
}
export type SimilarityRecovery = ReturnType<typeof buildSimilarityRecovery>;
